import { Component, OnInit, Inject } from '@angular/core';
import { MDC_DIALOG_DATA, MdcDialogRef } from '@angular-mdc/web';
import { FormGroup, FormControl } from '@angular/forms';
import { ContentService } from 'src/app/content.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-avslutt-forestilling',
  templateUrl: './avslutt-forestilling.component.html',
  styleUrls: ['./avslutt-forestilling.component.scss']
})
export class AvsluttForestillingComponent implements OnInit {
  public forestillinginfo;
  private id;
  public lukesalg;
  public nettsalg;
  public dxSalg;
  public eksternsalg;
  public annetsalgForm = new FormGroup({
    antall_billetter: new FormControl(null),
    snittpris: new FormControl({ value: null, disabled: true }),
    salg_totalt: new FormControl(null)
  });

  public solgtAvDX = false;

  constructor(
    @Inject(MDC_DIALOG_DATA) private data,
    private dialogRef: MdcDialogRef<any>,
    private contentService: ContentService
  ) {}

  ngOnInit() {
    this.id = this.data.id;
    forkJoin([
      this.contentService.fetchContent('/forestilling/' + this.id + '/info'),
      this.contentService.fetchContent('/salg/forestilling/' + this.id + '/solgte_billetter')
    ])
      .subscribe(res => {
        this.forestillinginfo = res[0]
        this.lukesalg = res[1].internsalg?.find(a => a.ordretype === 'luke');
        this.nettsalg = res[1].internsalg?.find(a => a.ordretype === 'nett');
        this.eksternsalg = res[1].eksternsalg;
        this.dxSalg = res[1].eksternsalg?.find(a => a.ordretype === 'DX');
        this.solgtAvDX = res[1].DX;
    })
    this.annetsalgForm.valueChanges.subscribe(form => {
      const antall = parseInt(this.annetsalgForm.value.antall_billetter);
      // const pris = parseInt(this.annetsalgForm.value.snittpris);
      const salg_totalt = parseInt(this.annetsalgForm.value.salg_totalt)
      if (!isNaN(salg_totalt) && !isNaN(antall)) {
        const snittpris = salg_totalt / antall;
        this.annetsalgForm.controls.snittpris.setValue(snittpris, { emitEvent: false});
      }
    })
  }

  avsluttForestilling() {
    //TODO Gjør noe annet for forestillinger der salget skal være gjort i DX
    if (this.solgtAvDX) {
      this.contentService.postContent(
        '/salg/forestilling/' + this.forestillinginfo.id + '/avslutt', {'eksternsalg': this.eksternsalg}
      ).subscribe(
        res => this.dialogRef.close(true)
      )
    }
    else {
      this.contentService.postContent(
        '/salg/forestilling/' + this.forestillinginfo.id + '/avslutt', this.annetsalgForm.value
      ).subscribe(
        res => this.dialogRef.close(true)
      )
    }
  }

  /* sjekker om vi har antall OG sum (over 0) - eller ingen av delene */
  prisOgAntallOK() {
    const v = this.annetsalgForm.value;

    if (v.antall_billetter==='') { v.antall_billetter=null; }
    if (v.salg_totalt==='') { v.salg_totalt=null; }

    // Begge null er OK
    if (v.antall_billetter===null && v.salg_totalt===null) {
      return true;
    }
    // Ellers må begge være ikke-null og ikke tom streng
    if (v.antall_billetter!==null && v.salg_totalt!==null) {
      return true;
    }
    return false;
  }

}
